import React from "react";
import Chart from "chart.js/auto";
import { Bar } from "react-chartjs-2";


const AVTBarChart = ({sditems,saleitems,label}) => {
  
   const data = {
    labels: sditems,
    datasets: [ {
         label: label,
         backgroundColor: "rgba(75, 192, 192, 0.6)",
         borderColor: "rgba(75, 192, 192, 0.6)",
         // backgroundColor: "rgb(53, 162, 235)",
         //borderColor: "rgba(53, 162, 235, 0.5)",
         data: saleitems, 
    }, ],
  };

 
  return (
    <div style={{ padding:"20px"}}>
      
      <Bar data={data} />
    </div>
  );
};

export default AVTBarChart;

